import { Injectable } from '@angular/core';
import { IApiBackendRouteService } from '../abstract/api-routes.service';
import { API_BASE_URL } from '../../../core/providers/constants/api.constants';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PlanningTaskWorkOrder } from '../types/planning-task';
import { ReportWorkOrder } from '../types/report';

@Injectable({
  providedIn: 'root',
})
export class ApiRouteInjectionMoldingService extends IApiBackendRouteService {
  urlRoute = `${API_BASE_URL}/injection-molding`;

  constructor(protected readonly http: HttpClient) {
    super();
  }

  openTasks(): Observable<PlanningTaskWorkOrder[]> {
    return this.http.get<PlanningTaskWorkOrder[]>(`${this.urlRoute}/planning`);
  }

  getInfoForCreatingInspection(
    workOrderId: number
  ): Observable<ReportWorkOrder[]> {
    return this.http.get<ReportWorkOrder[]>(
      `${this.urlRoute}/quality-control/info/create-inspection/${workOrderId}`
    );
  }
}
